import { render, staticRenderFns } from "./ApplyAreaList.vue?vue&type=template&id=d48bbb8e&"
import script from "./ApplyAreaList.vue?vue&type=script&lang=js&"
export * from "./ApplyAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports